import { useAtom } from "jotai";
import { menuOpenAtom } from "../../../atoms/layout.atoms";

export default function MenuButton() {
  const [isOpen, setIsOpen] = useAtom(menuOpenAtom);

  return (
    <button
      type="button"
      onClick={() => setIsOpen(!isOpen)}
      className="relative flex h-10 w-10 flex-col items-center justify-center gap-1.5 rounded-lg"
      aria-label={isOpen ? "Close menu" : "Open menu"}
      aria-expanded={isOpen}
    >
      <span
        className={`w-6 h-0.5 bg-current transition-all duration-300 ${
          isOpen ? "rotate-45 translate-y-2" : ""
        }`}
      />
      <span
        className={`w-6 h-0.5 bg-current transition-all duration-300 ${
          isOpen ? "opacity-0" : ""
        }`}
      />
      <span
        className={`w-6 h-0.5 bg-current transition-all duration-300 ${
          isOpen ? "-rotate-45 -translate-y-2" : ""
        }`}
      />
    </button>
  );
}
